import { Zap } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

const workflowTaskExecutionMethodOptions: ComboboxFilterOption<string>[] = [
  { label: 'Manual', value: 'manual' },
  { label: 'Automated', value: 'automated' },
]

const WorkflowTaskExecutionMethodFilter = (
  props: MultipleSelectedValuesFilter
) => {
  const [query, setQuery] = useState('')

  const filteredOptions = workflowTaskExecutionMethodOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          {
            groupLabel: 'Execution Method',
            options: filteredOptions || [],
          },
        ]}
        placeholder='Search execution methods to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={workflowTaskExecutionMethodOptions || []}
          noSelectionText='Execution Method'
          pluralIdentifier='execution methods'
        >
          <Zap size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default WorkflowTaskExecutionMethodFilter
